// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"522":"3ec27238","673":"825c4eaf","680":"8a82d8fe","866":"18f4011e","950":"72f74158","985":"af586728"}[chunkId] + ".css";
};